import { render } from "./ASClientiiNostri.vue?vue&type=template&id=18a1a89e&scoped=true"
import script from "./ASClientiiNostri.vue?vue&type=script&lang=js"
export * from "./ASClientiiNostri.vue?vue&type=script&lang=js"

import "./ASClientiiNostri.vue?vue&type=style&index=0&id=18a1a89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a1a89e"]])

export default __exports__